import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      "es-MX": ["es", "en"],
      default: ["es", "en"],
    },
    load: "languageOnly",
    debug: false,
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: ["createAcount", "logIn"], // namespace utilizados para diferentes partes de la app
    defaultNS: "translation",
    fallbackNS: ["faq", "footer", "createAcount", "logIn", "clientHome"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
